import '../App.css';

import "@chatscope/chat-ui-kit-styles/dist/default/styles.min.css";

import {
  MessageInput,
  MessageList,
  Message,
  MessageGroup,
  Avatar,
  ConversationHeader,
} from "@chatscope/chat-ui-kit-react";
import { useState, useEffect, useRef } from 'react';
import { formatTime } from './Components';
import { Base64Emoji } from './Base64Emoji';

export function MessageViewer({ messages, fetchImage, handleBankCardCopy, marginBottom }) {

  // 消息列表引用，自动跳转到底部
  const messageListRef = useRef(null);

  // 自动滚动到底部的函数
  const scrollToBottom = () => {
    messageListRef.current?.scrollToBottom('auto');
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      scrollToBottom();
    }, 300);

    return () => clearTimeout(timer);
  }, []);

  // 监听消息变化，自动滚动到底部
  useEffect(() => {
    scrollToBottom();
  }, [messages]);

  const createMessage = (data) => {
    if (data.type === 'image') {
      return (
        <ImageMessage dataUrl={data.url} id={data.id} fetchImage={fetchImage} />
      )
    } else if (data.type === 'custom') {
      return (
        <BankCardMessage data={JSON.parse(data.message)} onCopy={handleBankCardCopy} />
      )
    } else {
      return (
        <TextMessage message={data} />
      )
    }
  }

  return (
    <MessageList
      ref={messageListRef}
      scrollBehavior="smooth"
      style={{
        flex: 1,
        overflowY: "auto",
        marginBottom: marginBottom,
        height: "calc(100vh - 180px)", // 调整高度计算
      }}
    >
      {messages.map((v, index) => (
        <MessageGroup key={index} direction={v.direction}>
          {v.direction === 'incoming' ? <Avatar src='attendant.png' /> : ''}
          <MessageGroup.Messages>
            {createMessage(v)}
          </MessageGroup.Messages>
          {v.type !== 'text'
            ? <MessageGroup.Footer style={{
              display: 'flex',
              justifyContent: v.direction === 'incoming' ? 'flex-start' : 'flex-end'
            }}>
              <div style={{
                fontSize: '11px',
                color: '#999',
                marginTop: '4px'
              }}>
                {formatTime(v.sentTime)}
              </div>
            </MessageGroup.Footer>
            : ''}

        </MessageGroup>
      ))}
    </MessageList>
  )
}

// 银行卡消息组件
const BankCardMessage = ({ data, onCopy }) => {

  return (
    <div style={{
      width: '100%',
      maxWidth: '500px',
      backgroundColor: '#f8f9fa',
      borderRadius: '12px',
      overflow: 'hidden',
      boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
    }}>
      {/* 银行卡头部 */}
      <div style={{
        backgroundColor: '#1a1a1a',
        color: 'white',
        padding: '8px 12px',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center'
      }}>
        <span style={{
          fontSize: '18px',
          fontWeight: 'bold'
        }}>
          银行卡
        </span>
        <img style={{
          width: '30px',
          borderRadius: '15px',
          right: '0px',
          float: 'right',
          marginRight: '5px',
          marginTop: '0px',
          alt: '银行卡信息',
        }} src="photo_backOTC.jpg" />
      </div>

      {/* 银行卡信息 */}
      <div style={{ backgroundColor: '#e9ecef' }}>
        {bankCardFields.map((field) => (
          <BankCardRow
            key={field.key}
            label={field.label}
            value={data[field.key]}
            onCopy={() => {
              onCopy(field.label)
              try {
                copyText(data[field.key])
              } catch (err) {
                navigator.clipboard.writeText(data[field.key])
              }
            }}
          />
        ))}
      </div>
    </div>
  );
};

const copyText = (text) => {
  var input = document.createElement("input");
  input.value = text + "";
  input.style.position = "absolute";
  input.style.top = "0px";
  document.body.appendChild(input);
  input.select();
  input.setSelectionRange(0, input.value.length);
  document.execCommand('Copy');
  input.style.visibility = "hidden";
  input.remove();
};

// 银行卡字段配置
const bankCardFields = [
  { key: 'amount', label: '金额' },
  { key: 'accountName', label: '姓名' },
  { key: 'cardId', label: '卡号' },
  { key: 'bankName', label: '银行' }
];

// 银行卡行组件
const BankCardRow = ({ label, value, onCopy }) => (
  <div style={{
    display: 'flex',
    alignItems: 'center',
    padding: '0px 7px',
    fontSize: '13px',
    fontWeight: 'bold',
    color: '#333'
  }}>
    <span style={{ minWidth: '35px' }}>
      {label + ':'}
    </span>
    <span style={{
      flex: 1,
      wordBreak: 'break-all'
    }}>
      {value}
    </span>
    <button
      onClick={onCopy}
      style={{
        backgroundColor: '#28a745',
        color: 'white',
        border: 'none',
        borderRadius: '4px',
        fontSize: '12px',
        cursor: 'pointer',
        marginLeft: '6px',
      }}
    >复制</button>
  </div>
);

const TextMessage = ({ message }) => {
  return (
    <Message model={{}}>
      <Message.CustomContent>
        <div style={{
          maxWidth: '280px',
          wordWrap: 'break-word',
          fontSize: '14px',
          lineHeight: '1.4',
          display: 'flex',
          alignItems: 'flex-end', // 底部对齐
          gap: '8px'
        }}>
          {/* 消息文本 */}
          <div style={{
            flex: 1,
            minWidth: 0, // 允许文本收缩
            wordWrap: 'break-word'
          }}>
            {Base64Emoji.getEmoji(message.message)}
          </div>

          <div style={{
            fontSize: '11px',
            color: 'rgba(0, 0, 0, 0.5)',
            display: 'flex',
            alignItems: 'center',
            gap: '3px',
            flexShrink: 0, // 防止被压缩
            whiteSpace: 'nowrap', // 不换行
            userSelect: 'none'
          }}>
            <span>{formatTime(message.sentTime)}</span>
          </div>
        </div>
      </Message.CustomContent>
    </Message>
  );
};

function ImageMessage({ dataUrl, id, fetchImage }) {
  const [src, setSrc] = useState(dataUrl ?? '')
  useEffect(() => {
    if (!dataUrl && id) {
      async function fetchData() {
        const data = await fetchImage(id)
        setSrc(data)
      }
      fetchData();
    }
  }, [])
  return (
    <Message model={{
      sender: 'aaa',
    }}>
      <Message.ImageContent
        width={200}
        height={200}
        src={src}
      />
    </Message>
  )
}

export const ChatFooter = ({ status, onSend, onImageSelect, disabled = true }) => {
  const [value, setValue] = useState('');

  // 移除首尾空格
  const trim = (text) => {
    if (!text) return '';

    return text
      .replace(/&nbsp;/g, '\u00A0')  // HTML实体转Unicode
      .replace(/^[\s\u00A0\u200B\uFEFF]+|[\s\u00A0\u200B\uFEFF]+$/g, ''); // 清理首尾
  }

  const handleSend = (text) => {
    // emoji 编码
    text = Base64Emoji.setEmoji(trim(text));
    onSend(text)
    setValue('')
  }

  // 处理复制粘贴后的富文本内容
  const handlePaste = (event) => {
    event.preventDefault();

    // 获取粘贴内容
    const paste = (event.clipboardData || window.clipboardData).getData('text/html') ||
      (event.clipboardData || window.clipboardData).getData('text');

    // 清理HTML
    const div = document.createElement('div');
    div.innerHTML = paste;
    const plainText = (div.textContent || div.innerText || '').trim();

    // 插入纯文本
    setValue(prev => prev + plainText);
  };

  const textInput = () => {
    return (
      <div onPaste={handlePaste}>
        {status === 'WAITING'
          ? <div
            className='Prompt-bar'
            style={{ color: 'black', textAlign: 'center' }}
          >请咨询充值专员提供充值账号</div>
          : ''}
        <MessageInput
          autoFocus
          value={value}
          onChange={setValue}
          disabled={disabled}
          onSend={handleSend}
          onAttachClick={() => handleAttachmentClick(onImageSelect)}  // 附件点击处理

          style={{ padding: '5px' }}
          placeholder="请输入进行对话" />
      </div>);
  }

  const completedBar = () => {
    return (
      <div style={{
        backgroundColor: status === 'SUCCESS' ? 'green' : 'red',
        lineHeight: '40px',
        color: 'white',
        margin: '3px',
        borderRadius: '8px',
        textAlign: 'center'
      }}>
        {status === 'SUCCESS' ? '订单已完成' : '订单已取消'}
      </div>);
  }

  return (
    <div style={{
      position: "fixed",
      bottom: 0,
      left: 0,
      right: 0,
      zIndex: 2,
      borderTop: "1px solid #e0e0e0"
    }}>
      {status === 'WAITING' || status === 'AUDIT'
        ? textInput()
        : completedBar()}
    </div>
  )
}

export const ChatHeader = (orderId, amount, status, onClick) => {
  const isNotFinished = status !== 'SUCCESS' && status !== 'FAILED'
  const title = () => {
    return (
      <div style={{
        height: '30px',
        padding: '8px',
        backgroundClip: '#eceff1',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center'
      }}>
        <span>订单号: {orderId}</span>
        <span>金额: <span style={{
          color: 'red',
          fontWeight: 600,
          fontSize: '20px',
          marginLeft: '4px'
        }}>
          {amount}
        </span></span>

      </div>
    );
  }

  const paidButton = () => {
    const style = {
      textAlign: 'center',
      width: '80%',
      height: '30px',
      margin: '5px auto',
      backgroundColor: '#4CAF50',
      borderRadius: '5px',
      transitionDuration: '0.4s',
      cursor: 'pointer',
      border: '1px solid var(--grey)',
    }
    if (status === 'WAITING') {
      return (
        <div style={style}>
          <button onClick={onClick} >我已付款</button>
        </div>
      );
    } if (status === 'AUDIT') {
      return (
        <div style={style}>
          <button disabled >已付款，等待放行</button>
        </div>
      );
    }
  }

  return (
    <ConversationHeader style={{
      position: "sticky",
      top: 0,
      zIndex: 100,
      flexShrink: 0,
      padding: 0,
    }}>
      <ConversationHeader.Content>
        {title()}
        {isNotFinished ? divider() : ''}
        {isNotFinished ? paidButton() : ''}

      </ConversationHeader.Content>
    </ConversationHeader>
  )
}

const divider = () => {
  return (
    <div style={{
      borderBottom: '1px solid #000',
      width: '100%',
      borderColor: '#eceff1',
    }} />
  )
}

// 处理附件上传（仅限图片）
function handleAttachmentClick(callback) {
  // 创建一个隐藏的文件选择器
  const fileInput = document.createElement('input');
  fileInput.type = 'file';
  fileInput.accept = 'image/*'; // 只接受图片文件

  fileInput.onchange = (event) => {
    const files = Array.from(event.target.files);

    // 验证是否都是图片文件
    const imageFiles = files.filter(file => file.type.startsWith('image/'));
    if (imageFiles.length !== files.length) {
      alert('只能上传图片文件！');
      return;
    }

    const image = imageFiles[0]

    // 验证文件大小（限制每张图片最大 10MB）
    const maxSize = 10 * 1024 * 1024; // 10MB
    if (image.size > maxSize) {
      alert(`图片文件过大（超过10MB）`);
      return;
    }

    callback(image);
  };

  // 触发文件选择器
  fileInput.click();
};
